import Modal from 'components/Modal';
import React from 'react';
import IntlHelper from 'utils/helpers/intl.helper';

const NoSubjectDetail = () => {
  const t = IntlHelper.useTranslator();

  return (
    <>
      <Modal.Header title={t('no_subject_detail')} />
      <Modal.Footer
        withConfirmButton={false}
        closeButtonText={t('chiudi')}
      />
    </>
  );
};

export default NoSubjectDetail;
